/**
 * CRM Page — top-level CRM layout with tab navigation.
 * Feature-gated sub-feature tabs render conditionally.
 */

import { Routes, Route, Navigate } from 'react-router-dom'
import { Users } from 'lucide-react'
import { useFeature } from '@/hooks/useFeature'
import { PageFrame } from '@/components/layout/PageFrame'
import { PageHeader } from '@/components/layout/PageHeader'
import { CrmTabNav } from '@/components/crm/CrmTabNav'
import { ContactListView } from '@/pages/crm/ContactListView'
import { ContactDetailPage } from '@/pages/crm/ContactDetailPage'
import { DealsPage } from '@/pages/crm/DealsPage'
import { SegmentsPage } from '@/pages/crm/SegmentsPage'
import { ActivitiesPage } from '@/pages/crm/ActivitiesPage'
import { CompaniesPage } from '@/pages/crm/CompaniesPage'
import { AutomationsPage } from '@/pages/crm/AutomationsPage'
import { AnalyticsPage } from '@/pages/crm/AnalyticsPage'

export function CrmPage() {
  const dealsEnabled = useFeature('crm_deals')
  const segmentsEnabled = useFeature('crm_segments')
  const activitiesEnabled = useFeature('crm_activities')
  const companiesEnabled = useFeature('crm_companies')
  const automationsEnabled = useFeature('crm_automations')
  const analyticsEnabled = useFeature('crm_analytics')

  return (
    <PageFrame width="list" className="flex h-full flex-col gap-4">
      <PageHeader title="CRM" icon={Users}>
        <CrmTabNav />
      </PageHeader>
      <div className="min-h-0 flex-1">
        <Routes>
          <Route index element={<ContactListView />} />
          <Route path="contacts" element={<ContactListView />} />
          <Route path="contacts/:contactId" element={<ContactDetailPage />} />
          {/* Future phase routes — render placeholder until implemented */}
          {dealsEnabled && <Route path="deals/*" element={<DealsPage />} />}
          {segmentsEnabled && <Route path="segments/*" element={<SegmentsPage />} />}
          {activitiesEnabled && <Route path="activities/*" element={<ActivitiesPage />} />}
          {companiesEnabled && <Route path="companies/*" element={<CompaniesPage />} />}
          {automationsEnabled && <Route path="automations/*" element={<AutomationsPage />} />}
          {analyticsEnabled && <Route path="analytics/*" element={<AnalyticsPage />} />}
          <Route path="*" element={<Navigate to="" replace />} />
        </Routes>
      </div>
    </PageFrame>
  )
}
